import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { Template } from '@tools/interfaces/template';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-template-preview',
  components: {
    'bpc-entity-select': EntitySelect,
  },
})
export default class TemplatePreview extends Vue {
  @Prop(Object) readonly template: Template;

  get entityType(): string {
    return this.template.entity || null;
  }

  get entityName(): string {
    return (this.entityType || '').replaceAll('_', '-');
  }

  get entityLabel(): string {
    // TODO create a config option to know what field if the main field of an entity
    return 'id';
  }

  public html: string = '';
  public entity: AnyEntity = null;

  getTemplatePreview() {
    if (this.entity?.id) {
      const previewPath = `preview/${this.template.id}/${this.entity.id}`;
      this.$bpcApi
        .get(`${this.$bpcApiRouteHelper.getEntityPath('templates')}/${previewPath}`)
        .subscribe(res => {
          this.html = res.data;
        });
    }
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
